<template>
  <div class="home">
    <div v-show="loading" class="text-center text-primary mt-5">
      <b-spinner class="align-middle"></b-spinner>
      <strong class="ml-2">Cargando...</strong>
    </div>
    <div v-show="!loading">
      <b-row>
        <b-col>
          <h3
            class="mb-3 text-left"
            style="color: black"
            v-if="home.main_account"
          >
            Bienvenido, {{ home.main_account.user.first_name }}
          </h3>
        </b-col>
        <b-col>
          <h3 class="mb-3 text-right">
            Saldo total:
            <span style="color: black">$ {{ home.all_overview.balance }}</span>
          </h3>
        </b-col>
      </b-row>

      <b-card
        header-tag="header"
        header-class="card-color"
        class="mb-4"
        style="border-radius: 15px"
      >
        <template #header>
          <b-row align-v="center" align-h="between">
            <b-col lg="8" md="8" sm="8" cols="7">
              <div class="text-left card-title-white">Estado de cuenta</div>
            </b-col>
            <b-col lg="3" md="3" sm="3" cols="5">
              <b-button
                :to="{ name: 'PaymentReport' }"
                style="border-radius: 15px; border: none"
                class="btn-card-color pl-3 pr-3 pb-2 pt-2"
                size="sm"
              >
                <span class="text-font-white">Ingresar dinero</span>
              </b-button>
            </b-col>
          </b-row>
        </template>
        <b-card-text class="scroll">
          <b-list-group class="p-2" v-if="!home.main_account">
            <div class="text-font-black text-left">Principal</div>
            <b-list-group-item
              href="#"
              class="flex-column align-items-start"
              style="border-radius: 15px; border-color: #121419"
            >
              No hay cuentas registradas
            </b-list-group-item>
          </b-list-group>
          <div v-if="home.main_account">
            <div class="text-font-black text-left">Principal</div>
            <b-list-group class="p-2">
              <b-list-group-item
                :to="{
                  name: 'History',
                  params: { id: home.main_account.id },
                }"
                class="flex-column align-items-start"
                style="border-radius: 15px; border-color: #121419"
              >
                <b-row align-v="center" align-h="start">
                  <b-col md="3 ">
                    <img src="../assets/LogoSSBG.png" height="50px" alt="" />
                  </b-col>
                  <b-col md="6" v-if="home.main_account">
                    <h5 class="mb-1 text-font-black text-left">
                      {{ home.main_account.name }}
                    </h5>
                    <p class="mb-1 text-light-black text-left">
                      <strong
                        >Creado el {{ home.main_account.created_at }}</strong
                      >
                    </p>
                  </b-col>
                  <b-col md="3">
                    <p class="mb-1 text-light-black text-center">Saldo</p>
                    <h5
                      class="mb-1 text-font-black text-center"
                      style="font-size: 20px"
                    >
                      $ {{ home.main_account.overview.balance }}
                    </h5>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </div>
          <b-list-group class="p-2" v-if="!bank">
            <div class="text-font-black text-left">
              Cuentas bancarias asociadas
            </div>
            <b-list-group-item
              href="#"
              class="flex-column align-items-start"
              style="border-radius: 15px; border-color: #121419"
            >
              No hay cuentas registradas
            </b-list-group-item>
          </b-list-group>
          <!-- <div v-if="bank">
            <div class="text-font-black text-left">
              Cuentas bancarias asociadas
            </div>
            <b-list-group class="p-2" v-for="account of bank" :key="account.id">
              <b-list-group-item
                href="#"
                class="flex-column align-items-start"
                style="border-radius: 15px; border-color: #121419"
              >
                <b-row align-v="center" align-h="start">
                  <b-col md="3 ">
                    <img src="../assets/LogoSSBG.png" height="50px" alt="" />
                  </b-col>
                  <b-col md="6">
                    <h5 class="mb-1 text-font-black text-left">
                      {{ account.name }}
                    </h5>
                    <p class="mb-1 text-light-black text-left">
                      <strong
                        >#*******{{
                          account.number.substr(
                            account.number.length - 4,
                            account.number.length
                          )
                        }}</strong
                      >
                    </p>
                  </b-col>
                  
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </div> -->
        </b-card-text>
      </b-card>
      <b-card
        header-tag="header"
        header-class="card-color"
        class="mb-4"
        style="border-radius: 15px"
      >
        <template #header>
          <b-row align-v="center" align-h="between">
            <b-col lg="8" md="8" sm="8" cols="7">
              <div class="text-left card-title-white">Mis Colocaciones</div>
            </b-col>
            <b-col lg="3" md="3" sm="3" cols="5">
              <b-button
                :to="{ name: 'Invest' }"
                style="border-radius: 15px; border: none"
                class="btn-card-color pl-3 pr-3 pb-2 pt-2"
                size="sm"
              >
                <span class="text-font-white">Nueva Colocación</span>
              </b-button>
            </b-col>
          </b-row>
        </template>
        <b-card-text class="scroll">
          <div class="text-light-black text-left">
            Listado de colocaciones activas
          </div>
          <b-list-group class="p-2" v-if="!home.investments_accounts">
            <b-list-group-item
              href="#"
              class="flex-column align-items-start"
              style="border-radius: 15px; border-color: #121419"
            >
              No se han realizado colocaciones
            </b-list-group-item>
          </b-list-group>
          <div v-if="home.investments_accounts">
            <b-list-group
              class="p-2"
              v-for="invest of home.investments_accounts"
              :key="invest.id"
            >
              <b-list-group-item
                href="#"
                class="flex-column align-items-start"
                style="border-radius: 15px; border-color: #121419"
                :to="{ name: 'Balance', params: { id: invest.id } }"
              >
                <b-row align-v="center" align-h="start">
                  <b-col md="3">
                    <img src="../assets/LogoSSBG.png" height="50px" alt="" />
                  </b-col>
                  <b-col md="6">
                    <h5 class="mb-1 text-font-black text-left">
                      {{ invest.name }}
                    </h5>
                    <p class="mb-1 text-light-black text-left">
                      <strong
                        >Desde
                        {{
                          invest.created_at
                            .substr(0, 10)
                            .split("-")
                            .reverse()
                            .join("-")
                        }}</strong
                      >
                    </p>
                  </b-col>
                  <b-col md="3">
                    <p class="mb-1 text-light-black text-center">Saldo</p>
                    <h5
                      class="mb-1 text-font-black text-center"
                      style="font-size: 20px"
                    >
                      <span
                        v-if="invest.overview.earnings > 0"
                        style="color: green; font-size: 14px"
                        >+ {{ invest.overview.earnings }}%</span
                      ><span
                        v-if="invest.overview.earnings < 0"
                        style="color: red"
                        >- {{ invest.overview.earnings }}%</span
                      >
                      $ {{ invest.overview.balance }}
                    </h5>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-card-text>
      </b-card>
    </div>

    <!--Modal Add User-->
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "Home",
  data() {
    return {
      id_user: Cookies.get("id"),
      loading: false,
      progress: false,
      name: "",
      name2: "",
      email: "",
      account_type: "2",
      account_number: "",
      ach: "",
      location: "",
      cancel: false,
      type: 1,
      optionsTmp: [{ value: "2", text: "Banco de usuario" }],
      typeTmp: [{ value: 1, text: "Cuenta Bancaria" }],
      bank: [],
      account: [],
      home: {
        all_overview: {
          balance: 0,
        },
        investment_accounts: {},
        main_overview: {},
        main_account: {
          user: {},
          overview: {
            balance: 0,
          },
        },
      },
    };
  },
  mounted() {
    this.AllHome();
  },

  methods: {
    ...mapActions(["getHome", "CreateBankAccount", "getBank", "CreateAccount"]),
    resetModal() {
      if (this.cancel) {
        this.$nextTick(() => {
          this.$bvModal.hide("modal-bank");
        });
        this.cancel = false;
      }
      this.name = "";
      this.email = "";
      this.account_type = "2";
      this.account_number = "";
      this.ach = "";
    },
    AllHome() {
      this.loading = true;
      this.getHome()
        .then((response) => {
          if (response.code == 200) {
            this.home = response.data;
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        });
    },
  },
};
</script>
<style scoped>
.scroll {
  overflow: auto;
  overflow-x: hidden;

  max-height: 300px;
}
.card-header:first-child {
  border-radius: 15px 15px 0 0;
}
</style>